import { Component } from 'react';
import { ReactReduxContext } from 'react-redux';
import PropTypes from 'prop-types';
// @ts-expect-error not typed
import OldIndexControllerBusEventHandlers from 'ContentEditorUI/legacyHoldingPattern/oldIndexControllerBusEventHandlers';
// @ts-expect-error not typed
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import { jsx as _jsx } from "react/jsx-runtime";
class ScaffoldingContainer extends Component {
  constructor(...args) {
    super(...args);
    this.storeRef = null;
  }
  componentDidMount() {
    const {
      saveActions,
      bus
    } = this.props;
    const oldIndexControllerBusEventHandlers = new OldIndexControllerBusEventHandlers(this.storeRef, saveActions, bus);
    oldIndexControllerBusEventHandlers.registerAllLegacyEvents();
  }

  // This should only ever be rendered once
  shouldComponentUpdate() {
    return false;
  }
  saveStoreRefAndReturnNull(store) {
    this.storeRef = store;
    return null;
  }
  render() {
    return /*#__PURE__*/_jsx(ReactReduxContext.Consumer, {
      children: ({
        store
      }) => this.saveStoreRefAndReturnNull(store)
    });
  }
}
ScaffoldingContainer.propTypes = {
  saveActions: PropTypes.object.isRequired,
  bus: PropTypes.object.isRequired
};
export default withEditorActionsAndEvents(ScaffoldingContainer);